import { redirect } from "react-router";

import {
  DashboardBillingDocument,
  type StripeBillingPortalSessionQuery,
  type StripeBillingPortalSessionQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

export const DASHBOARD_STRIPE_LOADER = async () => {
  const returnURL = `${location.protocol}//${location.host}/dashboard`;

  const { data } = await client.query<
    StripeBillingPortalSessionQuery,
    StripeBillingPortalSessionQueryVariables
  >({
    query: DashboardBillingDocument,
    variables: { returnURL },
  });

  return redirect(data?.result?.url ?? returnURL);
};
